<div class="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-text-center">
  <img [src]="shareService.EditSVG" alt="edit-icon" class="tw-h-16 tw-w-16" />
  <h5 class="tw-m-0 smsir-h5-lg tw-text-[rgb(var(--text-primary))]">ویرایش متن پیامک</h5>
  <p class="tw-m-0 smsir-helper-lg tw-text-[rgb(var(--text-secondary))]">
    لطفا متن پیامک خود را وارد کنید.
  </p>
</div>

<div class="tw-mt-4">
  <app-text-builder
    (maxLenValidated)="validateMaxLength($event)"
    (messageTextChanged)="messageTextChanged($event)"
    [messageText]="text ? text : ''"
    [textBuilderType]="textBuilderTypeEnum.Textarea"
  ></app-text-builder>
</div>

<div class="tw-mt-6 tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-3 max-md:tw-grid max-md:tw-grid-cols-2">
  <button
    type="button"
    smsir-button
    httpLoading
    variant="secondary"
    size="sm"
    (click)="onSubmit()"
  >
    تایید
  </button>
  <button
    type="button"
    smsir-button
    variant="tertiary"
    size="sm"
    (click)="onCancel()"
  >
    بازگشت
  </button>
</div>
